import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ApiRequestPost } from "../../../data/network/services/ApiRequestPost";
import {
  startFullScreenLoadingAction,
  stopFullScreenLoadingAction,
} from "../../../data/redux/action/fullScreenLoadingAction";
import { CustomButton } from "../../components/customButton/CustomButton";
import { CustomInput } from "../../components/customInput/CustomInput";
import { BlackClear } from "../../resources/assetsManager";
import { SIDEBAR_COLOR, WHITE_COLOR } from "../../resources/colorsManager";
import { SUCCESS } from "../../resources/constantsManager";

const WebhookModal = ({
  closeModal,
  notifyUrl,
  validateUrl,
  currentStatus,
  onSuccess,
  email,
}) => {
  const [webHookUrl, setWebhookUrl] = useState("");
  const [otp, setOtp] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const dispatch = useDispatch();

  const onClickUpdateUrlValidate = () => {
    dispatch(startFullScreenLoadingAction());
    setLoading(true);
    ApiRequestPost.updateWebHookUrl(notifyUrl, webHookUrl, email, otp)
      .then((res) => {
        if (res.status === SUCCESS) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          onSuccess();
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
        dispatch(stopFullScreenLoadingAction());
      });
  };

  const onClickUpdateUrlNotify = () => {
    dispatch(startFullScreenLoadingAction());
    setLoading(true);
    ApiRequestPost.updateWebHookUrl(webHookUrl, validateUrl, email, otp)
      .then((res) => {
        if (res.status === SUCCESS) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          onSuccess();
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
        dispatch(stopFullScreenLoadingAction());
      });
  };

  useEffect(() => {
    if (webHookUrl !== "" && otp?.length === 6) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [otp, webHookUrl]);

  return (
    <div
      style={{
        width: "30%",
        minWidth: "400px",
        backgroundColor: WHITE_COLOR,
        padding: "20px 30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        borderRadius: "30px",
        position: "relative",
      }}
    >
      <p
        style={{
          color: "black",
          fontSize: "22px",
          margin: "10px 0px 30px 0px",
        }}
        className="roboto"
      >
        {" "}
        Update
      </p>

      <div
        style={{
          backgroundColor: "#E5E5E5",
          width: "36px",
          height: "36px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          right: "30px",
          top: "25px",
          borderRadius: "8px",
          cursor: "pointer",
        }}
        onClick={() => {
          closeModal();
        }}
      >
        <img src={BlackClear} alt="Clear" />
      </div>

      <div style={{ width: "100%", marginTop: "10px" }}>
        <CustomInput
          placeholder="OTP*"
          inputStyles={{
            backgroundColor: "#F3F3F3",
            border: "0px",
            height: "56px",
            borderRadius: "3px",
            color: "#000000",
            width: "100%",
            padding: "0px 15px",
            boxSizing: "border-box",
            fontSize: "16px",
            marginBottom: 20,
          }}
          onChange={(val) => {
            setOtp(val);
          }}
          value={otp}
          type="input"
          validator="otp"
        />
        <CustomInput
          placeholder="Webhook Url*"
          inputStyles={{
            backgroundColor: "#F3F3F3",
            border: "0px",
            height: "56px",
            borderRadius: "3px",
            color: "#000000",
            width: "100%",
            padding: "0px 15px",
            boxSizing: "border-box",
            fontSize: "16px",
          }}
          onChange={(val) => {
            setWebhookUrl(val);
          }}
          value={webHookUrl}
          type="input"
          validator="text"
        />
      </div>
      {/* <div style={{ width: "100%", marginTop: "10px" }}>
        <CustomInput
          placeholder="Secret"
          inputStyles={{
            backgroundColor: "#F3F3F3",
            border: "0px",
            height: "56px",
            borderRadius: "3px",
            color: "#000000",
            width: "100%",
            padding: "0px 15px",
            boxSizing: "border-box",
            fontSize: "16px",
          }}
        />
      </div> */}
      {/* <div
        style={{
          width: "100%",
          marginTop: "2px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <p
          style={{ margin: 0, fontSize: "12px", color: "#000000" }}
          className="roboto"
        >
          We strongly recommend to add secret for security
        </p>
        <p
          style={{ margin: 0, color: "#3783FB", fontSize: "14px" }}
          className="roboto"
        >
          Show Secret
        </p>
      </div> */}
      {/* <div style={{ width: "100%", marginTop: "10px" }}>
        <CustomInput
          placeholder="Alert"
          inputStyles={{
            backgroundColor: "#F3F3F3",
            border: "0px",
            height: "56px",
            borderRadius: "3px",
            color: "#000000",
            width: "100%",
            padding: "0px 15px",
            boxSizing: "border-box",
            fontSize: "16px",
          }}
        />
      </div> */}

      {/* <div style={{ width: "100%", marginTop: "10px" }}>
        <SelectLabel
          options={[
            { value: "Name", label: "name" },
            { value: "a", label: "name" },
          ]}
          //   value={issuer}
          //   onChange={(val) => {
          //     setIssuer(val);
          //   }}
        />
      </div> */}

      <CustomButton
        onClick={() => {
          currentStatus === 0
            ? onClickUpdateUrlValidate()
            : onClickUpdateUrlNotify();
        }}
        title="Add"
        styles={{
          backgroundColor: disabled ? "lightgrey" : SIDEBAR_COLOR,
          border: "0px solid",
          borderRadius: "3px",
          width: "100%",
          height: "50px",
          marginTop: "15px",
          marginBottom: "15px",
        }}
        textStyles={{
          color: disabled ? "black" : "white",
          cursor: disabled ? "disabled" : "pointer",
        }}
        loading={loading}
        disabled={disabled}
      />
    </div>
  );
};

export default WebhookModal;
